import cryptoRandomString from 'crypto-random-string';
import { Action } from 'redux-actions';
import _get from 'lodash/get';
import * as canvasBlocksActionTypes from '../constants/actionTypes/canvasBlocks';
import * as columnActionTypes from '../constants/actionTypes/column';
import * as columnItemActionTypes from '../constants/actionTypes/columnItem';
import rules from '../constants/businessRules/businessRules';

const canvasActions = [canvasBlocksActionTypes.ADD_BLOCK, canvasBlocksActionTypes.DUPLICATE_BLOCKS];
const columnActions = [columnActionTypes.MERGE_COLUMN, columnActionTypes.SPLIT_COLUMN];
const columnItemActions = [
    columnItemActionTypes.ADD_NEW_ITEM_FROM_PLACEHOLDER_TO_COLUMN,
    columnItemActionTypes.MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN,
    columnItemActionTypes.DUPLICATE_COLUMN_ITEM,
    columnItemActionTypes.ADD_NEW_COLUMN_ITEM,
];
const actionsRequiringIDs = [...canvasActions, ...columnActions, ...columnItemActions];

export const getIndices = (numOfBlocks = 1) => {
    const generateBlockID = () => cryptoRandomString({ length: 24 });
    const generateColumnID = () => cryptoRandomString({ length: 32 });
    const generateElementID = () => cryptoRandomString({ length: 36 });

    return {
        block: Array.from({ length: numOfBlocks }, () => generateBlockID()),
        column: Array.from({ length: rules.MAXIMUM_ALLOWABLE_BLOCK_COLUMN_NUMBERS * numOfBlocks }, () =>
            generateColumnID()
        ),
        element: Array.from(
            {
                length:
                    rules.MAXIMUM_ALLOWABLE_BLOCK_COLUMN_NUMBERS *
                    rules.MAXIMUM_ALLOWABLE_BLOCK_COLUMN_ITEMS *
                    numOfBlocks,
            },
            () => generateElementID()
        ),
    };
};

const generateIDsMiddleware = () => (next: (action: Action<any>) => void) => (action: Action<any>) => {
    const { payload, type } = action;
    if (payload && payload.remote) {
        next(action);
        return;
    }
    const actionRequiresIDGeneration = actionsRequiringIDs.includes(type);
    const numOfBlocks = _get(payload, 'blocks.length', 1);
    const newAction = actionRequiresIDGeneration
        ? { ...action, payload: { ...payload, indices: getIndices(numOfBlocks) } }
        : action;
    next(newAction);
};

export default generateIDsMiddleware;
